import { CRUD_GET_LIST, useGetList, useGetOne } from "ra-core"
import { useCallback, useEffect, useRef, useState } from "react"
import { RecPatch } from "@/dataProvider/tools"
import { DatabaseResponseDto, UpgradeStatus } from "@/gen/api/encrypt"
import { pages, sorts } from "@/utils/paramsWithGetMainList"

export const usePeekEncryptSettingChangeLocked = () => {
  // 'encrypted-dbs' api will only give db status about encrypted databases, but if we want to know
  // whether an unencrypted database is EncryptionSetting-locked, currently we will have to do another call
  const { data: encryptedDbData, loaded } = useGetList<DatabaseResponseDto&RecPatch>('encrypted-dbs', pages(), sorts(), {}, { action: CRUD_GET_LIST })
  const [reqDbId, setReqDbId] = useState(null as number|null)
  const { current: cached } = useRef({} as Record<number, boolean>)
  
  const { data: requestedDbStatus } = useGetOne(reqDbId ? 'db-esc-status' : 'noop', reqDbId || -1)
  useEffect(() => {
    const status = requestedDbStatus as DatabaseResponseDto
    if (status && reqDbId && status.databaseId === reqDbId) {
      cached[reqDbId] = status.upgradeStatus !== UpgradeStatus.Unlocked
    }
  }, [reqDbId, requestedDbStatus, cached])

  const peek = useCallback((databaseId?: number) => {
    if (!databaseId || !loaded || !encryptedDbData) { return undefined }
    
    if (encryptedDbData[databaseId]) {
      setTimeout(() => setReqDbId(v => null))
      return encryptedDbData[databaseId].upgradeStatus !== UpgradeStatus.Unlocked
    } else {
      if (cached.hasOwnProperty(databaseId)) {
        return cached[databaseId]
      } else {
        cached[databaseId] = false
        setTimeout(() => setReqDbId(databaseId))
        return false
      }
    }
  }, [encryptedDbData, loaded, cached])

  return peek
}